<template>
  <div class="goods-manage-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="filter-box">
          <div class="btn" @click="toGood('add')">+ 新建商品</div>
          <div class="btn-box">
            <div class="label">商品分区：</div>
            <el-select
              v-model="filter.partition"
              size="small"
              class="select"
              style="width: 120px"
              placeholder="请选择"
            >
              <el-option :value="null" label="全部"> </el-option>
              <el-option
                :value="item"
                :label="item"
                v-for="item in partitionList"
                :key="item"
              >
              </el-option>
            </el-select>
            <div class="label">商品分类：</div>
            <el-cascader
              v-model="category"
              :options="categoryList"
              placeholder="请选择"
              size="small"
              :props="{
                children: 'second',
                value: 'id',
                label: 'name',
                checkStrictly: true,
              }"
              class="good-input"
              style="width: 145px"
            ></el-cascader>
            <div class="label">商品状态：</div>
            <el-select
              v-model="filter.status"
              size="small"
              class="select"
              style="width: 120px"
              placeholder="请选择"
            >
              <el-option :value="null" label="全部"> </el-option>
              <el-option :value="3" label="出售中"> </el-option>
              <el-option :value="1" label="仓库中"> </el-option>
            </el-select>
            <!-- <div class="label">商品品牌：</div>
            <el-select
              v-model="filter.bid"
              size="small"
              class="select"
              style="width: 145px"
              placeholder="请选择"
            >
              <el-option :value="null" label="全部"> </el-option>
              <el-option
                :value="item.id"
                :label="item.name"
                v-for="item in brandList"
                :key="item.id"
              >
              </el-option>
            </el-select> -->
            <el-input
              class="input"
              v-model="filter.name"
              style="width: 160px; margin-left: 25px"
              placeholder="此框输入商品名搜索"
              size="small"
            ></el-input>
            <button class="search" @click="search">搜索</button>
            <div style="flex: 1"></div>
            <div class="btn" @click="batchBrand">设置商品品牌</div>
            <div class="btn btn2" @click="batchUpdateGoodsStatus(1)">
              批量下架
            </div>
            <div class="btn" @click="batchUpdateGoodsStatus(3)">批量上架</div>
            <div class="import-box">
              <div class="btn btn2" @click="order2excel">导出</div>
            </div>
          </div>
        </div>
        <el-table
          :data="goodsList"
          class="table table no-border-table"
          ref="orderTable"
          @selection-change="handleSelectionChange"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="master_pic" align="center" label="商品主图">
            <div slot-scope="scope">
              <!-- <img class="master-pic" :src="scope.row.masterPic" alt="" /> -->
              <el-image
                class="master-pic"
                :src="scope.row.masterPic"
                :preview-src-list="[scope.row.masterPic]"
              >
              </el-image>
            </div>
          </el-table-column>
          <el-table-column
            prop="id"
            align="center"
            label="商品ID"
          ></el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            prop="minPrice"
            align="center"
            label="价格/元"
          ></el-table-column>
          <el-table-column prop="groupingName" align="center" label="商品分类">
            <div slot-scope="scope">
              {{ scope.row.firstSortName + "/" + scope.row.secondSortName }}
            </div>
          </el-table-column>
          <el-table-column prop="partition" align="center" label="商品分区">
            <!-- <div slot-scope="scope">
              {{ scope.row.firstSortName + "/" + scope.row.secondSortName }}
            </div> -->
          </el-table-column>
          <el-table-column
            prop="brandName"
            align="center"
            label="商品品牌"
          ></el-table-column>
          <el-table-column prop="status" align="center" label="状态">
            <div slot-scope="scope">
              {{ scope.row.status === 3 ? "出售中" : "仓库中" }}
            </div>
          </el-table-column>
          <el-table-column
            prop="totalStock"
            align="center"
            label="库存"
          ></el-table-column>
          <el-table-column
            prop="channelsId"
            align="center"
            label="视频号编码"
          ></el-table-column>
          <!-- <el-table-column prop="twig" align="center" label="查看链接">
            <template slot-scope="scope">
              <u class="blue" @click="editSort(scope.row)">查看</u>
            </template>
          </el-table-column> -->
          <el-table-column prop="twig" align="center" label="排序">
            <template slot-scope="scope">
              <u class="blue" @click="editSort(scope.row)">{{
                scope.row.twig
              }}</u>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="twig"
            align="center"
            width="200"
            label="会员设置"
          >
            <template slot-scope="scope">
              <u class="blue" @click="priceSetting(scope.row.gid)">设置价格</u>
            </template>
          </el-table-column> -->
          <el-table-column label="操作" align="center" width="380">
            <div slot-scope="scope">
              <div class="table-btn-box">
                <button
                  size="mini"
                  class="table-btn"
                  v-if="scope.row.status === 3"
                  @click="syncLiveModal(scope.row.id, 1, 0)"
                >
                  同步至视频号
                </button>
                <button
                  size="mini"
                  class="table-btn"
                  v-if="scope.row.status === 3"
                  @click="updateStatus(1, scope.row.id)"
                >
                  下架
                </button>
                <button
                  size="mini"
                  class="table-btn"
                  v-else
                  @click="updateStatus(3, scope.row.id)"
                >
                  开售
                </button>
                <button
                  size="mini"
                  class="table-btn"
                  @click="toGood('edit', scope.row.id)"
                >
                  编辑商品
                </button>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteGood(scope.row.id)"
                >
                  删除商品
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer" :key="paginationKey">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 修改排序弹窗 -->
    <el-dialog title="更改排序" width="400px" :visible.sync="sortShow">
      <el-form label-width="60px" size="mini" ref="editSort" inline-message>
        <el-form-item label="排序：" prop="tableData" style="margin-top: 15px">
          <el-input v-model="currentSort" type="number" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="sortShow = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="saveSort">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="" width="1000px" :visible.sync="syncLiveShow">
      <div slot="title" style="display: flex;justify-content: center;">
        <!-- <el-steps :active="active" simple style="width: 360px">
          <el-step title="选择商品类目"></el-step>
          <el-step title="补充必填项"></el-step>
        </el-steps> -->
        <el-steps
          :active="active"
          direction="horizontal"
          finish-status="success"
          style="width: 360px"
        >
          <el-step title="选择商品类目"></el-step>
          <el-step title="补充必填项"></el-step>
        </el-steps>
      </div>
      <div class="wx-category-box" v-if="active === 1">
        <div class="step">
          <div
            class="item"
            v-for="(item, index) in list1"
            :key="index"
            :class="{ active: wxCategoryId1 === item.cat_id }"
            @click="getWxCategoryList(2, item.cat_id)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="step">
          <div
            class="item"
            v-for="(item, index) in list2"
            :key="index"
            :class="{ active: wxCategoryId2 === item.cat_id }"
            @click="getWxCategoryList(3, item.cat_id)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="step">
          <div
            class="item"
            :class="{ active: wxCategoryId3 === item.cat_id }"
            v-for="(item, index) in list3"
            :key="index"
            @click="wxCategoryId3 = item.cat_id"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="wx-category-box2" v-if="active === 2">
        <div class="title">需补充的必填项</div>
        <div class="list">
          <div class="item" v-for="(item, index) in attrs" :key="index">
            <div class="label">参数{{ index + 1 }}</div>
            <el-input
              v-model="item.name"
              size="small"
              class="input1"
              disabled
            ></el-input>
            <el-input
              v-model="item.attrValue"
              size="small"
              v-if="item.type === 'string'"
              :placeholder="`请输入${item.name}`"
              class="input2"
            ></el-input>
            <el-select
              v-if="item.type === 'select_one'"
              class="input2"
              v-model="item.attrValue"
              size="small"
              placeholder="请选择"
            >
              <el-option
                v-for="option in item.options"
                :key="option"
                :label="option"
                :value="option"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="syncLiveShow = false"
          >取 消</el-button
        >
        <el-button
          class="btn confirm-btn"
          v-if="active === 1"
          @click="handleStep"
          >下一步</el-button
        >
        <el-button class="btn confirm-btn" v-if="active === 2" @click="syncLive"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      title="生成中..."
      :visible.sync="showProgressDialog"
      width="30%"
      center
    >
      <el-progress
        :percentage="progress"
        :text-inside="true"
        :stroke-width="18"
      ></el-progress>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import dayjs from 'dayjs';
import Header from '../../components/common/header';
import myUtils from '../../components/common/whatever2excel';
export default {
  components: {
    Header
  },
  name: 'goods-manage',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '商品管理',
        secondTitle: '商品管理'
      },
      filter: {
        name: '',
        status: null,
        sid: null,
        partition: '',
        bid: null
      },
      goodsList: [], // 列表
      categoryList: [],
      currentId: null,
      currentSort: null,
      sortShow: false,
      paginationKey: +new Date(),
      category: [],
      businessList: [],
      showProgressDialog: false,
      progress: 0,
      statusMap: {
        1: '仓库中',
        3: '在售'
      },
      genreMap: {
        1: '自营商品',
        2: '供应链'
      },
      businessObj: {},
      partitionList: [
        '主推区',
        '优选区',
        '福利区',
        '直播区'
      ],
      syncLiveShow: false,
      active: 2,
      list1: [],
      list2: [],
      list3: [],
      wxCategoryId1: null,
      wxCategoryId2: null,
      wxCategoryId3: null,
      attrs: [],
      id: null,
      multipleSelection: [],
      brandList: []
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.name !== 'good') {
      sessionStorage.setItem('goodManage', '');
    }
    next();
  },
  mounted() {
    let data = sessionStorage.getItem('goodManage')
      ? JSON.parse(sessionStorage.getItem('goodManage'))
      : '';
    if (data) {
      console.log(data, 123);
      this.filter = {
        ...this.filter,
        ...data.filter
      };
      this.currentPage = data.currentPage;
      this.category = data.category || []
      this.paginationKey = +new Date();
      this.setSearchData();
    }
    // 获取列表
    this.getCategoryList();
    this.getBrandList();
    // this.getBusinessList();
    this.getGoodsList();
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  computed: {},
  methods: {
    setSearchData() {
      let goodManage = {
        currentPage: this.currentPage,
        filter: this.filter,
        category: this.category || []
      };
      sessionStorage.setItem('goodManage', JSON.stringify(goodManage));
    },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getGoodsList();
    },
    // 获取商品列表
    getGoodsList() {
      this.setSearchData();
      this.loading++;
      this.multipleSelection = [];
      this.httpGet(this.$root.getGoodsList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter,
        firstSortId: this.category[0] || 0,
        secondSortId: this.category[1] || 0
      }).then(
        (res) => {
          this.loading--;
          this.goodsList = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 获取品牌列表
    getBrandList() {
      this.loading++;
      this.httpGet(this.$root.getBrandList, {
      }).then(
        (res) => {
          this.loading--;
          this.brandList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    getBusinessList() {
      this.loading++;
      this.httpGet(this.$root.getBusinessList, {
        size: 9999
      }).then(
        (res) => {
          this.loading--;
          this.businessList = res.list;
          let businessObj = {};
          res.list.forEach(item => {
            businessObj[item.id] = item.name;
          });
          this.businessObj = businessObj;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 获取分类列表
    getCategoryList() {
      this.loading++;
      this.httpGet(this.$root.getGoodsCategoryList, {}).then(
        (res) => {
          this.loading--;
          this.categoryList = res.list.filter((item) => item.second.length);
          this.categoryList.unshift({
            name: '全部',
            id: 0
            // second: [
            //   {
            //     name: '全部',
            //     id: 0,
            //     fid: 0
            //   }
            // ]
          });
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 过滤
    search() {
      console.log(this.filter);
      this.currentPage = 1;
      this.getGoodsList();
    },
    editSort(rowData) {
      // 更改排序
      this.currentId = rowData.id;
      this.sortShow = true;
      this.currentSort = rowData.twig;
    },
    saveSort() {
      // 保存排序
      this.loading++;
      this.httpPut(this.$root.updateGoodsTwig, {
        id: +this.currentId,
        twig: +this.currentSort
      }).then(
        (res) => {
          this.$message({
            message: '修改成功！',
            type: 'success'
          });
          this.getGoodsList();
          this.loading--;
          this.sortShow = false;
        },
        (err) => {
          this.loading--;
          this.$message.error(err);
        }
      );
    },
    batchBrand(){
      if(!this.multipleSelection.length){
        this.$message.error('请选择商品');
        return;
      }
      this.$router.push({
        name: 'batchBrand',
        query: {
          list: JSON.stringify(this.multipleSelection.map(item => {return {id: item.id, name: item.name}}))
        }
      });
    },
    batchUpdateGoodsStatus(status){
      if(!this.multipleSelection.length){
        this.$message.error('请选择商品');
        return;
      }
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定将商品批量${
          status === 1 ? '下架' : '上架'
        }？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.batchUpdateGoodsStatus, {
          list: this.multipleSelection.map(item => {
            return {
              id: item.id,
              status: status
            }
          }),
        }).then(
          (res) => {
            this.loading--;
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getGoodsList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    updateStatus(status, id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要将商品${
          status === 1 ? '放入仓库' : '开售'
        }吗</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.updateGoodsStatus, {
          id,
          status
        }).then(
          (res) => {
            this.loading--;
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getGoodsList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    syncLiveModal(gid, step, id = 0){
      this.syncLiveShow = true;
      this.id = gid;
      this.wxCategoryId2 = null;
      this.wxCategoryId3 = null;
      this.list2 = [];
      this.list3 = [];
      this.active = 1;
      this.getWxCategoryList(step, id);
    },
    getWxCategoryList(step, id){
      if(step === 2){
        this.wxCategoryId1 = id;
        this.wxCategoryId2 = null;
        this.wxCategoryId3 = null;
        this.list2 = [];
        this.list3 = [];
      } else if(step === 3){
        this.wxCategoryId2 = id;
        this.wxCategoryId3 = null;
        this.list3 = [];
      }
      this.loading++;
      this.httpGet(this.$root.getWxCategoryList, {
        id
      }).then(
        (res) => {
          this.loading--;
          this[`list${step}`] = res;
        },
        (err) => {
          this.loading--;
          this.$message.error(err);
        }
      );
    },
    setWxCategoryId(){

    },
    handleStep(){
      if(!this.wxCategoryId3){
        this.$message.warning("请选择类目");
        return;
      }
      this.active = 2;
      this.loading++;
      this.httpGet(this.$root.getWxCategoryInfo, {
        id: this.wxCategoryId3
      }).then(
        (res) => {
          this.loading--;
          this.attrs = res.attr.product_attr_list;
          this.attrs = this.attrs.map(item => {
            if(item.type === 'select_one'){
              item.options = item.value.split(';');
            };
            // item.attrValue = '';
            return {...item, attrValue: ''}
          })
        },
        (err) => {
          this.loading--;
          this.$message.error(err);
        }
      );
    },
    syncLive(){
      console.log(this.attrs);
      let flag = false;
      let attrs = [];
      this.attrs.forEach(item => {
        if(!item.attrValue) flag = true;
        attrs.push({
          attr_key: item.name,
          attr_value: item.attrValue
        })
      });
      if(flag){
        this.$message.warning("请填写信息");
        return;
      }
      this.loading++;
      this.httpPost(this.$root.syncProduct, {
        id: this.id,
        attrs,
        cats: [
          {
            cat_id: this.wxCategoryId1
          },
          {
            cat_id: this.wxCategoryId2
          },
          {
            cat_id: this.wxCategoryId3
          }
        ]
      }).then(
        (res) => {
          this.loading--;
          this.syncLiveShow = false;
          this.$message({
              message: '同步成功',
              type: 'success'
            });
        },
        (err) => {
          this.loading--;
          this.$message.error(err);
        }
      );
    },
    // 删除商品
    deleteGood(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除商品吗</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteGoods, {
          id
        }).then(
          (res) => {
            this.loading--;
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getGoodsList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 添加/编辑商品
    toGood(type, id) {
      this.$router.push({
        name: 'good',
        query: {
          type,
          id
        }
      });
    },
    priceSetting(gid) {
      this.$router.push({
        name: 'priceSetting',
        query: {
          gid
        }
      });
    },
    showSetting(gid) {
      this.$router.push({
        name: 'showSetting',
        query: {
          gid
        }
      });
    },
    async order2excel() {
      this.loading++;
      let goodsList = [];
      let totalPage = null;
      let data = {
        page: this.currentPage,
        size: this.size,
        ...this.filter,
        firstSortId: this.category[0] || 0,
        secondSortId: this.category[1] || 0
      };
      await this.httpGet(this.$root.getGoodsList, data).then(
        (res) => {
          this.loading--;
          totalPage = Math.ceil(parseInt(res.total) / this.size);
        },
        () => {
          this.loading--;
        }
      );
      this.showProgressDialog = true;
      this.progress = 0;
      await this.getAllPages(totalPage, goodsList).then(
        () => {
          this.showProgressDialog = false;
          this.jsonFormatAndToExcel(goodsList);
        },
        (err) => {
          console.error(err);
          this.showProgressDialog = false;
        }
      );
    },
    async getAllPages(totalPage, list) {
      for (let i = 1; i <= totalPage; i++) {
        let data = {
          page: i,
          size: this.size,
          ...this.filter,
          firstSortId: this.category[0] || 0,
          secondSortId: this.category[1] || 0
        };
        await this.httpGet(this.$root.getGoodsList, data).then((res) => {
          list.push(...res.list);
          this.progress = Math.floor((i / totalPage) * 100);
          console.log('page' + i, list.length);
        });
        // console.log(5555, list);
      }
    },
    getAttrs(attrs) {
      return attrs
        .map((item) => {
          return item.keyName + '：' + item.value;
        })
        .join('; ');
    },
    jsonFormatAndToExcel(list) {
      let formatList = [];
      list.forEach((item) => {
        let obj = {
          商品ID: item.id,
          商品名称: item.name,
          价格: item.linePrice,
          商品分类: item.firstSortName + '-' + item.secondSortName,
          商品分区: item.partition,
          状态: this.statusMap[item.status],
          库存: item.totalStock,
          视频号编码: item.channelsId,
          商品品牌: item.brandName,
          创建时间: item.created
          // 商品类型: this.genreMap[item.genre],
          // '当前月销量（含基础销量）': item.monthlySales,
          // 商品商家: this.businessObj[item.sid],
          // 成本: item.cost,
          // 卖价: item.linePrice,
          // 视频号编码: item.channelsId,
          // 总库存: item.skuList.reduce((pre, cur) => {
          //   return pre + cur.stock;
          // }, 0)
        };
        // item.skuList.forEach((sku, index) => {
        //   obj[`规格${index + 1}`] = this.getAttrs(sku.attrs);
        //   obj[`规格${index + 1} 价格`] = sku.price;
        //   obj[`规格${index + 1} 库存`] = sku.stock;
        //   obj[`规格${index + 1} 编码`] = sku.code;
        // });
        formatList.push(obj);
      });
      // console.log(formatList);
      myUtils.json2excel(formatList);
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.goods-manage-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    .blue {
      color: btn-color;
      cursor: pointer;
    }

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      .filter-box {
        flex-wrap: wrap;
        flex-y(flex-start, flex-start);

        .btn-box {
          width: 100%;
          margin: 5px 0;
          flex-x(flex-start);
          flex-wrap: wrap;

          .label {
            margin-right: 6px;
            margin-left: 12px;
            word(14px, gray3);
          }

          .input {
            margin-right: 8px;
          }

          .search {
            min-width: 65px;
          }
          .btn{
            margin-left: 6px;
          }
        }
      }

      .import-box {
        flex-x(flex-end);
      }

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin: 5px 0;
        flex-shrink: 0;
        box-sizing: border-box;
      }

      .btn2{
        color: #606266;
        background: #fff;
        border: 1px solid #E8E8E8;
      }

      .table {
        .master-pic {
          width: auto;
          height: 36px;
        }
      }

      .vip-btn {
        width: 96px;
        height: 24px;
        border-radius: 4px;
        border: 1px solid #E8E8E8;
        background: #F7F7F7;
        word(12px, btn-color);
        flex-x(center);
        white-space: nowrap;
        margin: 0 5px;
        cursor: pointer;
      }

      .table-btn-box {
        flex-x(flex-end);

        .table-btn {
          width: 80px;
          min-width: 80px;
          height: 24px;
          line-height: 24px;
          color: gray3;
          font-size: 12px;
          margin-right: 8px;
          cancel-btn();
        }
      }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }

  .wx-category-box{
    flex-x();
    padding: 5px 0;
    background: #F7F7F7;
    .step{
      flex: 1;
      height: 320px;
      border-right: 1px solid #D8D8D8;
      background: #F7F7F7;
      padding: 0 10px;
      box-sizing: border-box;
      overflow-y: auto;
      .item{
        height: 36px;
        flex-x();
        padding: 0 12px;
        box-sizing: border-box;
        border-radius: 5px;
        &:hover{
          background: #F8E8E5;
        }
        &.active{
          background: #F8E8E5;
        }
      }
      &:nth-of-type(1){
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      &:nth-of-type(3){
        border-right: none;
      }
    }
  }
  .wx-category-box2{
    padding: 0 24px;
    box-sizing: border-box;
    .list{
      margin-top: 36px;
    }
    .item{
      margin: 6px 0;
      flex-x(flex-start);
      .label{
        width: 65px;
      }
      .input1{
        width: 160px;
      }
      .input2{
        width: 200px;
        margin-left: 12px;
      }
    }
  }
}
</style>
